exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#scadaPointCard .v--modal-box.v--modal{min-width:600px!important;min-height:320px!important}#scadaPointCard .modal__content{overflow-y:auto!important}.watch-icon{font-size:14px;cursor:default}#archive-measures__container,#current-measures__container{width:100%;margin-left:0;display:flex;justify-content:space-between}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e7da891","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/scada/modals/ScadaPointCard.vue
// module id = 1707
// module chunks = 0